// extracted by mini-css-extract-plugin
module.exports = {"seriesRatingWrapper":"fx","ratingTooltip":"fy"};